import React, { useId } from 'react'
import { CloseIcon } from './icons'

type ChatTeaserProps = {
  operatorName: string
  text: string
  replyLabel: string
  closeLabel: string
  onReply: () => void
  onClose: () => void
}

const initials = (name: string): string =>
  name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? '')
    .join('')

/**
 * Compact proactive nudge shown above the launcher. Small on purpose: a single
 * operator line plus a Reply button that opens the full chat, and a close (×)
 * that dismisses it. Only rendered while the panel is collapsed.
 */
export const ChatTeaser: React.FC<ChatTeaserProps> = ({
  operatorName,
  text,
  replyLabel,
  closeLabel,
  onReply,
  onClose,
}) => {
  const descId = useId()
  return (
    <div
      className="wc-teaser"
      role="dialog"
      aria-label={operatorName}
      aria-describedby={descId}
    >
      <button
        type="button"
        className="wc-teaser-close"
        aria-label={closeLabel}
        onClick={onClose}
      >
        <CloseIcon />
      </button>
      <div className="wc-teaser-body">
        <span className="wc-avatar wc-teaser-avatar" aria-hidden="true">
          {initials(operatorName)}
        </span>
        <p id={descId} className="wc-teaser-text">
          {text}
        </p>
      </div>
      <button type="button" className="wc-teaser-reply" onClick={onReply}>
        {replyLabel}
      </button>
    </div>
  )
}
